import ContentContainer from './content-container';
export default ContentContainer;